import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  isSideMenuCollapsed = signal<boolean>(false);
}
